const CloseX = ({ width }) => {
    return (
        <div className={`close-x ${width}`}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76.68 76.68">
                <g fill="currentColor">
                    <path d="M71.67 0L0 71.67l5.01 5.01L76.68 5.01z"></path>
                    <path d="M76.68 71.67L5.01 0 0 5.01l71.67 71.67z"></path>
                </g>
            </svg>
        </div>
    )
}

export default CloseX
